import { Component, Input, OnInit } from "@angular/core";
import { DynamicPanel, GroupPanel } from '../../interfaces';
import { ServiceAgent } from 'src/app/framework-modules/formdata/form/serviceAgent';
import { SessionComponent } from '../../component';
import { FormData, TabularData } from 'src/app/framework-modules/formdata/form/formData';
import { StaffForm, StaffFd } from 'src/app/framework-modules/formdata/gen/staffForm';
import { CtDialogComponent } from 'src/app/framework-modules/elements/ct-dialog/component';
import { MatDialog } from '@angular/material';

@Component({
  selector: "staff-edit",
  templateUrl: "./component.html",
  styleUrls: ["./component.scss"]
})


export class StaffEditComponent implements DynamicPanel, OnInit {
  @Input() inputData: any;
  @Input() parentPanel: GroupPanel;
  @Input() session: SessionComponent;

  public form: StaffForm;
  public fd: StaffFd;

  constructor(private sa: ServiceAgent, private dialog: MatDialog) {
    this.form = StaffForm.getInstance();
    this.fd = new StaffFd(this.form, this.sa);
  }

  ngOnInit() {
    this.fd.setFieldValue('staffId', this.inputData);
    this.fd.fetchData().subscribe({
      next: vo => {
      },
      error: msg => console.error("Error from server ", msg)
    });
  }

  save(){
    let dialogRef = this.dialog.open(CtDialogComponent);
    dialogRef.componentInstance.title = 'Save Changes';
    dialogRef.componentInstance.content = 'Are you sure you want to save changes?';
    dialogRef.componentInstance.primary = 'Save';
    const subscribeDialog = dialogRef.componentInstance.save.subscribe((data) => {
      this.dialog.closeAll();
      this.doSave();
    });
  }

  doSave() {
    this.fd.save().subscribe({
      next: vo => {
        this.parentPanel.navigate("StaffList");
      },
      error: err => {
        console.error(err);
      }
    });
  }

  doCancel() {
    let dialogRef = this.dialog.open(CtDialogComponent);
    dialogRef.componentInstance.title = 'Discard Changes';
    dialogRef.componentInstance.content = 'Are you sure you want to discard changes?';
    dialogRef.componentInstance.primary = 'Discard';
    const subscribeDialog = dialogRef.componentInstance.save.subscribe((data) => {
      this.dialog.closeAll();
      this.parentPanel.navigate('StaffList');
    }); 
  }

}
